<template>
  <div class="panel flex">
    <div class="ynqy">
      <p>
        <span class="num">{{ qysl }}</span
        >(个)
      </p>
      <p>园内企业</p>
      <img src="~images/index/home/yn.png" alt="" />
    </div>
    <div class="navHead flex">
      <div class="cube">
        <div class="name">国家级龙头企业</div>
        <div>
          <span class="num">{{ gnqy }}</span
          ><span class="unit">（个）</span>
        </div>
      </div>
      <div class="cube">
        <div class="name">省级龙头企业</div>
        <div>
          <span class="num">{{ njqy }}</span
          ><span class="unit">（个）</span>
        </div>
      </div>
      <div class="cube">
        <div class="name">市级龙头企业</div>
        <div>
          <span class="num">{{ sjqy }}</span
          ><span class="unit">（个）</span>
        </div>
      </div>
      <div class="cube">
        <div class="name">其他企业</div>
        <div>
          <span class="num">{{ qtqy }}</span
          ><span class="unit">（个）</span>
        </div>
      </div>
    </div>
    <div class="devideLine"></div>
  </div>
</template>

<script>
import { getScreenV2DataProcessGetCompanyNum } from "@/api/home";
export default {
  data() {
    return {
      gnqy: "",
      njqy: "",
      sjqy: "",
      qtqy: "",
      qysl: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getScreenV2DataProcessGetCompanyNum({ year: 2021 }).then(res => {
        let qy = res.data;
        this.gnqy = qy.ntqy_gjj;
        this.njqy = qy.ntqy_province;
        this.sjqy = qy.ntqy_city;
        this.qtqy = qy.qtqy;
        this.qysl = qy.qysl;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 25%
.navHead
  height calc(100% - 2px)
  padding 0 10px
  width 66%
  flex-wrap wrap
  justify-content space-around
.ynqy
  width 33%
  position relative
  height 100%
  p:nth-child(1)
    position absolute
    z-index 1
    top 30%
    left 50%
    transform translate(-50%,-50%)
    color #FFAE00
    margin-bottom .05rem
    font-size .06rem

    span
      font-size .18rem
  p:nth-child(2)
    z-index 1
    position absolute
    top 60%
    left 50%
    transform translate(-50%,-50%)
    font-size .06rem

  img
    position absolute
    top 50%
    left 50%
    transform translate(-50%,-50%)
    z-index 0
.cube
  width 40%
  text-align center
  .num
    font-size 0.13rem
  .num, .unit
    color $textColor
.unit
  font-size 0.06rem
.devideLine
  height 2px
  background linear-gradient(to right, transparent, #0B305C, #155782, #0B305C, transparent)
.name
  font-size 0.08rem
  background url('~images/index/home/name.png')
  background-size 100% 50%
  background-repeat no-repeat
  background-position bottom
@media (max-width 1280px)
  .unit
    font-size 0.08rem
  .name
    font-size 0.08rem
</style>
